import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DataPortalComponent} from './data-portal.component';
import {CoreModule} from '../core.module';
import {SharedModule} from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import {DashboardComponent} from './dashboard/dashboard.component';
import {
  SidePanelComponent
} from './dashboard/side-panel/side-panel.component';
import {
  GoodStandingOrganizationComponent
} from './dashboard/good-standing-widgets/good-standing-organization/good-standing-organization.component';
import {
  AnnualReportsOrganizationComponent
} from './dashboard/annual-report-widgets/annual-reports-organization/annual-reports-organization.component';
import {
  SafeFromHarmOrganization
} from './dashboard/safe-from-harm-widget/safe-from-harm-organization/safe-from-harm-organization';
import {SafeFromHarmWorld} from './dashboard/safe-from-harm-widget/safe-from-harm-world/safe-from-harm-world';
import {CensusWidgetComponent} from './dashboard/census-widget/census-widget.component';
import {GlobalSupportComponent} from './dashboard/global-support/global-support.component';
import {InteractionsComponent} from './dashboard/interactions/interactions.component';
import {ProjectsCountComponent} from './dashboard/projects-count/projects-count.component';
import {ConstitutionOrganizationComponent} from './dashboard/constitutions/constitution-organization/constitution-organization.component';
import {CompliencyComponent} from './dashboard/compliency/compliency.component';
import {
  PolicyDocumentDetailOrganizationComponent
} from './dashboard/policy-document-detail-widgets/policy-document-detail-organization/policy-document-detail-organization.component';
import {
  PolicyDocumentsOrganizationComponent
} from './dashboard/policy-documents-widgets/policy-documents-organization/policy-documents-organization.component';
import {SummaryNoteComponent} from './dashboard/summary-note/summary-note.component';
import {FederationsComponent} from './dashboard/federations/federations.component';
import {InteractionDetailComponent} from './dashboard/interaction-detail/interaction-detail.component';
import {ReportComponent} from './dashboard/annual-report-widgets/annual-reports-organization/report/report.component';
import {InteractionSearchComponents} from './dashboard/interaction-detail/interaction-search/interaction-search.component';
import {AdministrationDataPortalModule} from './administration-data-portal/administration-data-portal.module';
import {CensusDetailComponent} from './dashboard/census-detail/census-detail.component';
import {AgeGroupTotalComponent} from './dashboard/census-detail/age-group-total/age-group-total.component';
import {AddCustomAgeGroupsComponent} from './dashboard/census-detail/add-custom-age-groups/add-custom-age-groups.component';
import {BeneficiariesComponent} from './dashboard/census-detail/beneficiaries/beneficiaries.component';
import {CensusGraphsComponent} from './dashboard/census-graphs/census-graphs.component';
import {
  GoodStandingRegionWorldComponent
} from './dashboard/good-standing-widgets/good-standing-region-world/good-standing-region-world.component';
import {
  AnnualReportsRegionWorldComponent
} from './dashboard/annual-report-widgets/annual-reports-region-world/annual-reports-region-world.component';
import {ConstitutionRegionWorldComponent} from './dashboard/constitutions/constitution-region-world/constitution-region-world.component';
import {
  PolicyDocumentsRegionWorldComponent
} from './dashboard/policy-documents-widgets/policy-documents-region-world/policy-documents-region-world.component';
import {DeltaComponent} from './dashboard/delta/delta.component';
import {
  PolicyDocumentDetailRegionWorldComponent
} from './dashboard/policy-document-detail-widgets/policy-document-detail-region-world/policy-document-detail-region-world.component';
import {SliderModule} from 'primeng/slider';
import { CensusExportComponent } from './dashboard/census-detail/census-export/census-export.component';
import { NdpExportComponent } from './ndp-export/ndp-export.component';
import {CustomWidgetsComponent} from "./dashboard/custom-widgets/custom-widgets-component";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    AdministrationDataPortalModule,
    SliderModule,
    TranslateModule
  ],
  declarations: [
    DataPortalComponent,
    DashboardComponent,
    SidePanelComponent,
    GoodStandingOrganizationComponent,
    AnnualReportsOrganizationComponent,
    SafeFromHarmOrganization,
    SafeFromHarmWorld,
    CensusWidgetComponent,
    GlobalSupportComponent,
    InteractionsComponent,
    ProjectsCountComponent,
    ConstitutionOrganizationComponent,
    CompliencyComponent,
    PolicyDocumentDetailOrganizationComponent,
    PolicyDocumentsOrganizationComponent,
    SummaryNoteComponent,
    FederationsComponent,
    InteractionDetailComponent,
    ReportComponent,
    InteractionSearchComponents,
    CensusDetailComponent,
    AgeGroupTotalComponent,
    AddCustomAgeGroupsComponent,
    BeneficiariesComponent,
    CensusGraphsComponent,
    GoodStandingRegionWorldComponent,
    AnnualReportsRegionWorldComponent,
    ConstitutionRegionWorldComponent,
    PolicyDocumentsRegionWorldComponent,
    CensusGraphsComponent,
    DeltaComponent,
    PolicyDocumentDetailRegionWorldComponent,
    CensusExportComponent,
    NdpExportComponent,
    CustomWidgetsComponent
  ],
  exports: [
    DataPortalComponent,
    CustomWidgetsComponent
  ]
})
export class DataPortalModule {
}
